//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { Row } from "components/styles";
import { TextData } from "views/components/Schedules/components/UpdateActivityPopup/styles";
//#endregion
//#region Components
import HandlerRadio from "components/CustomRadio/CustomRadio";
import Preloader from "components/Preloader/Preloader";
//#endregion
//#region Services
import { requestTakeAttendance } from "services/appointment/aboutAppoinment";
//#endregion
//#region Utils
import useMainContext from "utils/context/useMainContext";
import { ATTENDANCE_OPTIONS, VALUES_BY_ATTENDANCE_OPTIONS } from "../utils/constants";
import useScheduleComponentContext from "views/Asesorias/components/AppointmentSchedules/components/SchedulesComponent/utils/context/useScheduleComponentContext";
//#endregion

const AttendanceControl = ({
    reservation: {
        id: reservationId, 
        attended
    },
    isTimeAppointment
}) => {
    const mainContext = useMainContext();
    const { changeReservationAttendance } = useScheduleComponentContext();
    //#region States
    const [newAttended, setNewAttended] = useState(true);
    const [loading, setLoading] = useState(false);
    //#endregion
    useEffect(() => {
        setNewAttended(attended);
    }, [attended]);
    //#region Functions
    const areThereChange = id => {
        const newValue = id === 1;
        return newAttended !== newValue;
    }
    const changeNewAttended = async id => {
        if (!areThereChange(id)) return;
        setLoading(true);
        const newValue = VALUES_BY_ATTENDANCE_OPTIONS[id];
        const success = await requestTakeAttendance(
            reservationId, 
            newValue
        );
        setLoading(false);
        // Fix por aparición del scroll en el body
        document.body.classList.add("no-scroll");
        if (!success) {
            // Setteo de nuevo valor de asistencia
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }
        // Setteo de nuevo valor de asistencia
        changeReservationAttendance(reservationId, newValue);
    }
    const getAttended = () => {
        if (newAttended !== null)
            return newAttended !== null ? newAttended ? 1 : 2 : 0;
        return attended !== null ? attended ? 1 : 2 : 0;
    }
    //#endregion
    return (
        <>
        <Row>
            <TextData>¿Asistió el/ la estudiante?</TextData>
            <HandlerRadio 
                radiosProps={ATTENDANCE_OPTIONS}
                // disabled={!isTimeAppointment}
                value={getAttended()}
                onChange={changeNewAttended}/>
        </Row>
        <Preloader hidden={!loading} message="Guardando asistencia..."/>
        </>
    );
}

export default AttendanceControl;